<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="100%"
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          :label="label"
          hide-details="auto"
          class="datainput justify-content-end align-self-center pb-1"
          dense
          outlined
          readonly
          :clearable="clearable"
          @click:clear="clearButtonClicked"
          v-bind="attrs"
          v-on="on"
          :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
        v-model="dateRange"
        range
        no-title
        show-adjacent-months
        @input="onDateChange"
      ></v-date-picker>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    clearable: Boolean,
    value: String,
    disabled: Boolean,
  },

  data() {
    return {
      menu: false,
      dateFormatted: null,
      dateRange: [],
    };
  },

  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.dateRange = this.parseDateRange(newValue);
        this.updateDateFormatted();
      },
    },
  },

  methods: {
    clearButtonClicked() {
      this.date = null;
      this.dateRange = [];
      this.dateFormatted = null;
      sessionStorage.removeItem("orderDate");
      this.$emit("input", null);
    },

    onDateChange() {
      if (this.dateRange.length === 1) {
        this.dateFormatted = this.formatDate(this.dateRange[0]);
      } else if (this.dateRange.length === 2) {
        this.updateDateFormatted();
        this.checkAndCloseMenu();
      }
    },

    updateDateFormatted() {
      if (this.dateRange && this.dateRange.length === 2) {
        let [startDate, endDate] = this.dateRange;

        if (startDate > endDate) {
          [startDate, endDate] = [endDate, startDate];
          this.dateRange = [startDate, endDate];
        }

        this.dateFormatted = `${this.formatDate(startDate)} - ${this.formatDate(
          endDate
        )}`;
        this.$emit(
          "input",
          `${this.formatDate(startDate)} to ${this.formatDate(endDate)}`
        );
      } else {
        this.dateFormatted = null;
        //this.$emit("input", null);
      }
    },

    formatDate(date) {
      const parsedDate = new Date(date);

      if (isNaN(parsedDate.getTime())) {
        return "";
      }
      const day = String(parsedDate.getDate()).padStart(2, "0");
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0");
      const year = parsedDate.getFullYear();
      const formattedDate = `${day}.${month}.${year}`;
      return formattedDate;
    },

    checkAndCloseMenu() {
      if (this.dateRange && this.dateRange.length === 2) {
        this.menu = false;
      }
    },
    parseDateRange(rangeString) {
      if (rangeString) {
        const dateRegex = /(\d{2})\.(\d{2})\.(\d{4})/g;
        const dates = [...rangeString.matchAll(dateRegex)].map((match) => {
          const [_, day, month, year] = match;
          return `${year}-${month}-${day}`; // ISO format
        });
        return dates.length === 2 ? dates : [];
      } else return null;
    },
  },
};
</script>
